import React from "react";

/**
 *
 * @param {{pregunta:string,respuesta:string}} param
 * @returns
 */
const InfoGarantia = ({ pregunta, respuesta }) => {
  return (
    <div className='w-100 container__info mb-5 py-5'>
      <div className='mx-5'>
        <h1 className='text-center text-primary' style={{ fontSize: "40px" }}>
          {pregunta}
        </h1>
        <p className='text-center' style={{ fontSize: "24px" }}>
          {respuesta}
        </p>
      </div>
    </div>
  );
};

export default InfoGarantia;
